var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 8.25H4.125C3.51721 8.25 2.93432 8.00856 2.50455 7.57879C2.07478 7.14902 1.83333 6.56612 1.83333 5.95833C1.83333 5.35055 2.07478 4.76765 2.50455 4.33788C2.93432 3.90811 3.51721 3.66667 4.125 3.66667H5.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 8.25H17.875C18.4828 8.25 19.0657 8.00856 19.4955 7.57879C19.9252 7.14902 20.1667 6.56612 20.1667 5.95833C20.1667 5.35055 19.9252 4.76765 19.4955 4.33788C19.0657 3.90811 18.4828 3.66667 17.875 3.66667H16.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.66667 20.1667H18.3333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.16667 13.4383V15.5833C9.16667 16.0875 8.73583 16.4817 8.2775 16.6925C7.19583 17.1875 6.41667 18.5533 6.41667 20.1667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.8333 13.4383V15.5833C12.8333 16.0875 13.2642 16.4817 13.7225 16.6925C14.8042 17.1875 15.5833 18.5533 15.5833 20.1667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.5 1.83333H5.5V8.25C5.5 9.70869 6.07946 11.1076 7.11091 12.1391C8.14236 13.1705 9.54131 13.75 11 13.75C12.4587 13.75 13.8576 13.1705 14.8891 12.1391C15.9205 11.1076 16.5 9.70869 16.5 8.25V1.83333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F2C230"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatEvent);
export default __webpack_public_path__ + "static/media/cat_event.8a705223db72229edbfe1ecb6fb6feee.svg";
export { ForwardRef as ReactComponent };